import { memo } from "react";
import PropTypes from "prop-types";

function ComplexTableHead({ headings }) {
  return (
    <thead>
      <tr>
        {headings.map(({ key, children }) => {
          return (
            <th key={key} className="noselect">
              {children}
            </th>
          );
        })}
      </tr>
    </thead>
  );
}

ComplexTableHead.propTypes = {
  headings: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      children: PropTypes.node,
    }),
  ).isRequired,
};

export default memo(ComplexTableHead);
